// extracted by mini-css-extract-plugin
export default {"usersPage":"Allusers_usersPage__-O6XA","breadcrumb":"Allusers_breadcrumb__ZvNuA","newProject":"Allusers_newProject__5BGnh","link":"Allusers_link__dm0jU"};